// Module
var code = "<div class=\"intro\"> <div class=\"main-contents\"> <img class=\"{{emblemClassName}}\" id=\"emblem\" data-ng-src=\"{{brand.emblem.url}}\" alt> </div> </div> ";
// Exports
export default code;